import { render, staticRenderFns } from "./DatatablePageLayout.vue?vue&type=template&id=48d622f5&"
import script from "./DatatablePageLayout.vue?vue&type=script&lang=js&"
export * from "./DatatablePageLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports